import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { routes } from '@/config/routes';
import Navbar from '@/components/Navbar';
import { Starfield ,Message} from 'starry-sky-ui';
import AdminLayout from '@/pages/Admin/AdminLayout';
import { recordVisit } from '@/service/visit';
import { MascotProvider } from '@/components/FloatingMascot/mascot-context';
import FloatingMascot from '@/components/FloatingMascot';
import './index.scss';

const Layout: React.FC = () => {
  const location = useLocation();

  // 路由切换时记录访客访问
  useEffect(() => {
    // 跳过后台管理和大屏页面
    if (location.pathname.startsWith('/admin') || location.pathname === '/demo/visualize') {
      return;
    }

    // 归一化动态路由：/blog/article/48 → /blog/article
    const pageUrl = location.pathname.replace(/^\/(blog|interview-question)\/article\/\d+$/, '/$1/article');

    recordVisit(pageUrl, navigator.userAgent).then((res) => {
      if (!res.data) {
        return;
      }
      localStorage.setItem('province', res.data ?? '');
    });
  }, [location.pathname]);

  const renderElement = (route: (typeof routes)[number]) => {
    const Component = route.component;

    // 需登录的路由，未登录时跳转登录页
    if (route.auth && !localStorage.getItem('token')) {
      return <Navigate to="/admin/login" replace />;
    }

    // Admin 非登录页面用 AdminLayout 包裹
    if (route.path.startsWith('/admin') && route.path !== '/admin/login') {
      return (
        <AdminLayout>
          <Component />
        </AdminLayout>
      );
    }

    return <Component />;
  };

  return (
    <div className="App">
      <Navbar />
      <main className="main-content">
        <Starfield />
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={renderElement(route)}
            />
          ))}
        </Routes>
      </main>
      {location.pathname === '/' && (
        <footer className="app-footer">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            浙ICP备2026011820号
          </a>
          <span className="app-footer__sep">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            浙ICP备2026011820号-1
          </a>
        </footer>
      )}

      <FloatingMascot />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <MascotProvider>
      <Router>
        <Layout />
        <Message />
      </Router>
    </MascotProvider>
  );
};

export default App;
